"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * 同构的 createPortal
 */
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var useEnhancedEffect = typeof window !== 'undefined' ? react_1.default.useLayoutEffect : react_1.default.useEffect;
function Portal(props) {
    var children = props.children;
    var _a = react_1.useState(null), mountNode = _a[0], setMountNode = _a[1];
    useEnhancedEffect(function () {
        if (document.body) {
            var div = document.createElement('div');
            document.body.appendChild(div);
            setMountNode(div);
        }
        return function () {
            if (mountNode && document.body) {
                document.body.removeChild(mountNode);
            }
        };
    }, []);
    return mountNode ? react_dom_1.createPortal(children, mountNode) : null;
}
exports.default = Portal;
//# sourceMappingURL=index.js.map